import { render, staticRenderFns } from "./RsaConfigurazioneLaboratoriListComponent.vue?vue&type=template&id=4816cd26"
import script from "./RsaConfigurazioneLaboratoriListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneLaboratoriListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports